<template>
    <wx-open-launch-app id="launch-btn" :appid="launch_app_id" :extinfo="appUrl" @error="wxerrorFn" @launch="launch" @ready="ready">
        <component :is="'script'" type="text/wxtag-template">
            <div style="width:100px;height:200px;" class="templete">11111111111111</div>
        </component>
    </wx-open-launch-app>
</template>

<script setup lang="ts">

const props = defineProps<{
    launch_app_id: string;
    appUrl: "jihuanshe://www.jihuanshe.com/app/user?entrance=&userId=1111114";
}>();

console.log(props.launch_app_id)
console.log(props.appUrl)

// const launch_app_id = ref("wxe513b81e8994343a")

const wxerrorFn = (e: any) => {
    // alert('微信开放标签错误: ' + JSON.stringify(e));
    window.location.href = "https://sj.qq.com/appdetail/com.jihuanshe?&from_wxz=1"
}
const launch = () => {
    console.log('开始跳转')
}
const ready = ()=> {
    console.log('准备好了')
}
</script>

<style scoped>
.templete {
    width: 100%;
    height: 100%;
}

#launch-btn {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 20;
  background: red;
}
</style>